import React, { useState } from "react";
import {
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
  CardTitle,
  CardText
} from "reactstrap";
// import { MenuItemDetail } from './MenuItemDetail';
import { MobileMenuItemDetail } from "./MobileMenuItemDetail";

// import './Menu.css';

export const MobileMenuItem = ({ item, selectedTable, onOrderUpdate,index,setOrderPlaced,tables,setSelectedTable }) => {
  const [modal, setModal] = useState(false);

  const toggleModal = () => setModal(!modal);
  const amountAfterDiscount =
    item.discountDetail && item.discountDetail.discountPercentage
      ? item.price - (item.price * item.discountDetail.discountPercentage) / 100
      : item.price;

  const handleOrderComplete = async () => {
    await onOrderUpdate();
    toggleModal();
  };
  return (
    // lg={3} md={4}  sm={6}  pt-1 p-0 m-0 //leftside ps-sm-5 ps-md-5 ps-lg-5 ps-xl-5  rightside ps-2
    // <div  className={`mb-3 green col-6  col-sm-5 ps-2  completeCard ${index%2==0 ? "LeftfooditemsCard" : " RightfooditemsCard"}`}>
    // <div  className={`mb-3 red col-6  col-sm-5 col-md-4 col-lg-3  d-flex justify-content-center align-items-center`}>
    // <div  className={`mb-3 red col-6  col-sm-5 col-md-4 col-lg-3  d-flex `}>
    <Col xs={4} sm={3} lg={2} className="  d-flex">

<Card
        className="foodItemActualCard  ribbon-box"
        style={{ boxShadow: "0px 2px 2px 0px #F3F3F9"}}
        onClick={toggleModal} 
      >
        <div className=" " style={{height: "4rem"}}>
          <img
            src={item?.cloudR2ImagePath?.getCDNUrl() || 'https://via.placeholder.com/150'}
            alt={item.title}
            className="w-100 h-100 object-fit-cover"
            
          />
        </div>

        <div className="mt-2">
          <div className="text-center title-mobilemenuitem" >{item.title}</div>
          
            <p className="p-0 fs-6 mt-2 text-center price-mobilemenuitem">
            {item.discountDetail && item.discountDetail.discountPercentage > 0 ? (
              <>
                <span className="text-decoration-line-through me-2 text-danger">Rs. {item.price}</span>
                <span className='text-black'>Rs. {amountAfterDiscount}</span>
                {item.discountDetail && item.discountDetail.discountPercentage > 0 && (
            <div className="ribbon-two ribbon-two-primary">
              <span className=" ms-2">
                {item.discountDetail.discountPercentage}% OFF
              </span>
            </div>
          )}
              </>
            ) : (
              <span className='text-black'>Rs. {item.price}</span>
            )}
          </p>
      
          
        </div>
      </Card>
     

      {/* <Card
        className="foodItemActualCard green ribbon-box"
        style={{ boxShadow: "0px 2px 2px 0px #F3F3F9"}}
        onClick={toggleModal} 
      >
        <div className="red " style={{height: "4rem"}}>
          <img
            src={item?.cloudR2ImagePath?.getCDNUrl() || 'https://via.placeholder.com/150'}
            alt={item.title}
            className="w-100 h-100 object-fit-cover"
            
          />
        </div>

        <div className="mt-2">
          <div className="text-center title-mobilemenuitem" >{item.title}</div>
          
            <p className="p-0 fs-6 mt-2 text-center price-mobilemenuitem">
            {item.discountDetail && item.discountDetail.discountPercentage > 0 ? (
              <>
                <span className="text-decoration-line-through me-2 text-danger">Rs. {item.price}</span>
                <span className='text-black'>Rs. {amountAfterDiscount}</span>
                {item.discountDetail && item.discountDetail.discountPercentage > 0 && (
            <div className="ribbon-two ribbon-two-primary">
              <span className=" ms-2">
                {item.discountDetail.discountPercentage}% OFF
              </span>
            </div>
          )}
              </>
            ) : (
              <span className='text-black'>Rs. {item.price}</span>
            )}
          </p>
      
          
        </div>
      </Card> */}

          {/* {item.discountDetail && item.discountDetail.discountPercentage > 0 && (
            <div className="ribbon-two ribbon-two-primary">
              <span className=" ms-2">
                {item.discountDetail.discountPercentage}% OFF
              </span>
            </div>
          )} */}

      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>{item.title}</ModalHeader>
        <ModalBody>
          <MobileMenuItemDetail
            item={item}
            onClose={handleOrderComplete}
            selectedTable={selectedTable}
            setOrderPlaced={setOrderPlaced}
            tables={tables}
            setSelectedTable={setSelectedTable}
          />
        </ModalBody>
      </Modal>
      
    </Col>
  );
};
